/** LOGIN ERROR MESSAGES */

const LOGIN_INCORRECT_CREDENTIALS = 'Username and password combination is incorrect. Please try again!';
const LOGIN_OFFLINE = 'You must be connected to the internet to log in.';
const LOGIN_UNEXPECTED = 'Unexpected error occurred. You will need to re-login.';
const LOGIN_NO_COMPANIES = 'Login Failed: No companies found for user.';
const LOGIN_GETTING_COMPANY = 'Login Failed: Error finding current company.';
const LOGIN_CURRENT_COMPANY_NOT_FOUND = 'Login Failed: current company not found.';

export default {
  LOGIN_INCORRECT_CREDENTIALS,
  LOGIN_OFFLINE,
  LOGIN_UNEXPECTED,
  LOGIN_NO_COMPANIES,
  LOGIN_GETTING_COMPANY,
  LOGIN_CURRENT_COMPANY_NOT_FOUND,
};



// WEBPACK FOOTER //
// ./src/constants/ErrorConstants.js